import React from 'react';
import Box from '../Box/Box';
import { ActionImageIconButton } from '../IconButton';

type TActionIcon = {
  className?: string;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  icon: string;
  tabIndex?: string;
};

const ActionIcon = ({ icon, onClick }: TActionIcon) => {
  return (
    <Box as="div" name="action-icon" className="action-icon">
      <ActionImageIconButton name={icon} onClick={onClick} tabIndex="0" />
    </Box>
  );
};

export default ActionIcon;
